/* eslint-disable camelcase */
import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import SyncableModel from "../../../../database/SyncableModel";
import { Appearance, ViewStyle } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { FarmShrimpPriceForm as ModelForm, ModelCreateScreen, useRouteName, DeleteModal, Text } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { FarmStoreModel } from "../../../../models/app-store/farm-store/farm-store"
import JalaAnalytic from "../../../../utils/jala-analytic"
import { FarmShrimpPrice, ShrimpPrice } from "../../../../database"
import { goBack } from "../../../../navigators"
import moment from "moment";

export const FarmShrimpPriceCreateScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function FarmShrimpPriceCreateScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmStore, farmId },
    // farmShrimpPriceStore: modelStore,
    shrimpPriceStore: modelStore,
    farmShrimpPriceStore,
    userStore: { user }
  } = useStores();
  const { activeBatchStore, lastFarmShrimpPrice } = farmStore || FarmStoreModel.create()

  const { routeNameRef, previousRouteNameRef } = useRouteName()
  const [ modelFarmShrimpPrice, setModelFarmShrimpPrice ] = useState<SyncableModel>(null)
  const [ modelShrimpPrice, setModelShrimpPrice ] = useState<SyncableModel>(null)

  const initialValues = useMemo<any>(() => {
    const data = (modelFarmShrimpPrice ? modelFarmShrimpPrice.toArray() : params)
    return {
      farm_id: farmId,
      shrimp_price_id: lastFarmShrimpPrice && lastFarmShrimpPrice.shrimp_price_id || null,
      region_id: farmStore.farm?.region_id,
      country_id: farmStore.farm?.country_id || 'ID',
      private: data ? data.private : null
    }
  }, [farmId, farmStore.farm?.country_id, farmStore.farm?.region_id, lastFarmShrimpPrice, modelFarmShrimpPrice, params])

  useEffect(() => {
    const farmShrimpPrice = params && farmStore.farmShrimpPrices.find((m) => m.id === params.id);
    if (farmShrimpPrice) {
      const model = FarmShrimpPrice.hydrate({ ...farmShrimpPrice })
      setModelFarmShrimpPrice(model)
    }
    JalaAnalytic.log('Mobile app: home - overview - setting harga jual');
  }, [farmStore, params, setModelFarmShrimpPrice])

  useEffect(() => {
    if (params && params?.id) {
      JalaAnalytic.log('Mobile app: home - overview - setting harga jual');
      const model = ShrimpPrice.hydrate({ ...params });
      setModelShrimpPrice(model)
    }
  }, [params, params?.id])

  const onSuccess = useCallback((success: boolean) => {
    if (modelStore.needRefresh) {
      if (success) {
        activeBatchStore.getCycleActualAndPredictions(true, () => {
          modelStore.set('needRefresh', null)
          modelStore.set('pushIdQueue', {})
        })
      } else {
        modelStore.set('needRefresh', null)
        modelStore.set('pushIdQueue', {})
      }
    }
    return success;
  }, [activeBatchStore, modelStore])

  const onSubmit = useCallback(async (data: any) => {
    modelStore.set('loading', true)
    const { id, creator, created_at, source, ...dataNew } = data
    let success = false;
    if (modelStore && source === 'private') {
      const isCreator = creator && creator.id === user.id
      const isToday = moment().utc(created_at).format('YYYY-MM-DD') ===  moment.utc().format('YYYY-MM-DD')
      success = !(modelShrimpPrice && isCreator && isToday)
        ? await modelStore.store(dataNew, async (success, model) => {
          JalaAnalytic.log('Mobile App : Private Shrimp Price');
          await farmShrimpPriceStore.store({ farm_id: farmId, shrimp_price_id: model.getKey() })
        })
        : await modelStore.update(modelShrimpPrice, data).then(async (success) => {
          JalaAnalytic.log('Mobile App : Private shrimp price edit');
          await farmShrimpPriceStore.store({ farm_id: farmId, shrimp_price_id: modelShrimpPrice.getKey() })
          return success;
        })
    } else {
      success = await farmShrimpPriceStore.store({ farm_id: farmId, shrimp_price_id: data.id })
      JalaAnalytic.log('Mobile App : Public Shrimp Price');
    }
    JalaAnalytic.log("Mobile app: Form On Submit", {
      form: ModelForm.displayName || 'Unknown',
      data: JSON.stringify(data || null),
      success,
      routeName: routeNameRef.current,
      previousRouteName: previousRouteNameRef.current
    })
    if ((!onSuccess || onSuccess(success)) && success) {
      goBack('Home.Stack')
    }
    modelStore.set('loading', false)
  }, [farmId, farmShrimpPriceStore, modelShrimpPrice, modelStore, onSuccess, previousRouteNameRef, routeNameRef, user.id])

  return (<>
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={modelFarmShrimpPrice}
      hideOnBlurred={false}
      onSubmit={onSubmit}
      ignoreDirty
    />
  </>)
})
